import styled from 'styled-components';

export const StyledAccountDetails = styled.div`
  display: table;
`;

export const StyledRow = styled.div`
  display: table-row;
`;

export const StyledCell = styled.div`
  display: table-cell;
`;

export const StyledLabel = styled(StyledCell)`
  min-width: 220px;
`;
